import { useSelector } from "react-redux";
import { Container } from "@remo-co/ui-core";
import ReactedEmoji from "../ReactedEmoji/ReactedEmoji";
import { getAnimationData } from "../Reactions/utils";
import Clap from "../assets/emoji_clap.png";
import Like from "../assets/emoji_thumbs.png";
import { EmojiReactionType } from "../Reactions/types";
import Confused from "../assets/emoji_monocle.png";
import { selectIsRemojiEnabled } from "../../event/selectors";

interface IEmojiType {
  name: EmojiReactionType;
  imageType: string;
}

const emojiTypes = [
  { name: "clap" as EmojiReactionType, imageType: Clap },
  { name: "like" as EmojiReactionType, imageType: Like },
  { name: "confused" as EmojiReactionType, imageType: Confused },
];

const EmojiButtonContainer = () => {
  const isRemojiEnabled = useSelector(selectIsRemojiEnabled);

  if (!isRemojiEnabled) {
    return null;
  }

  return (
    <Container
      flex
      justifyContent="space-between"
      data-testid="emoji-button-container"
    >
      {emojiTypes.map((emoji: IEmojiType) => (
        <ReactedEmoji
          key={emoji.name}
          type={emoji.name}
          imageType={emoji.imageType}
          animationData={getAnimationData(emoji.name)}
        />
      ))}
    </Container>
  );
};

export default EmojiButtonContainer;
